export var iconButtonMarginRightPixels = '4px';
export var iconMaxHeightPixels = '16px';
export var squareButtonSizePixels = '32px';
//# sourceMappingURL=constants.js.map